import React, { useState, useEffect } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { useAppContext } from "../libs/contextLib";
import { s3GetWithBucket } from "../libs/awsLib";
import Button from 'react-bootstrap/Button';
import { useLoader } from '../context/LoaderContext';
import * as Constants from "../constants/classificationsConstants";
import "./Stamps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Stamps() {
    const { isAuthenticated, business } = useAppContext();
    const [ downloaded, hasDownloaded ] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [,setLoading] = useLoader();

    useEffect(() => {
        //ensures window scrolls to top when loading this page
        window.scrollTo(0, 0);
        
        async function onLoad() {
            if (!isAuthenticated) {
                return;
            }
            setIsLoading(false);
        }

        onLoad();
    }, [isAuthenticated]);

    useEffect(() => {
        setLoading(isLoading);
    }, [setLoading, isLoading]);

    const downloadStamps = async () => {

        try {
            //Determine the classifications business has access to
            
            if (business && business.classifications && business.classifications.length > 0) {
                
                //Always give Small Business stamps as a part of download
                var hasSmallBusiness = business.classifications.includes('Small Business');
                if (!hasSmallBusiness) {
                    business.classifications.push("Small Business");
                }
                
                business.classifications.forEach(async (classification) => {
                    //get Classification and determine stamp image
                    var stampsBucket = Constants.classificationsDisplayMap[classification].zipFileS3Bucket;
                    var stampsFileName = Constants.classificationsDisplayMap[classification].zipFileName;

                    //Download image blob using s3 link
                    //stamps zip files are in a different bucket
                    const s3Url = await s3GetWithBucket(stampsBucket + stampsFileName, "sert-consumer");
                    let blob = await fetch(s3Url).then(r => r.blob());
                    if (blob) {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = Constants.classificationsDisplayMap[classification].zipFileName;
                        link.click();
                    }
                    hasDownloaded(true);
                });
        
            }
        } catch (e) {
            //TODO: show error modal
            //console.log("*****image not found: ");
        }
    }

    return (
        <div className="stamps">
            {isAuthenticated && (
                <div className="content">
                    <div className="contentHeader row-bottom-20">
                        <div>
                            <h2>Download Sertify Stamps</h2>
                            <h4>Easily add Sertify Stamps yourself or forward them to your marketer. They are sized and ready to upload to your digital assets.</h4>
                        </div>
                    </div>
                    <div className="contentBody">
                        <ul>
                            <li>Your Website</li>
                            <li>Email Campaigns</li>
                            <li>Facebook Photo Gallery</li>
                            <li>Instagram Photo Gallery</li>
                            <li>Google Photo Gallery</li>
                            <li>Yelp Photo Gallery</li>
                            <li>Twitter Post</li>
                        </ul>
                    </div>
                    <div className="contentBody">
                        <div className="downloadStamps">
                            <div onClick={event => downloadStamps()} rel="noopener noreferrer" download title="Download Sertify images">
                                <FontAwesomeIcon icon={['fas', 'cloud-download-alt']} size="4x"></FontAwesomeIcon>
                            </div>
                            <div>
                                <span>&nbsp;
                                { !downloaded && (
                                    <>Download</>
                                )}
                                { downloaded && (
                                    <>Download complete &nbsp;<FontAwesomeIcon icon={['fas', 'check']} ></FontAwesomeIcon></>
                                )}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="pageButtons-single row-top-10">
                        <LinkContainer key="nextHome" to="/home">
                            <Button variant="primary">DONE</Button>
                        </LinkContainer>
                    </div>
                </div>
            )}
        </div>
    );
}